import YesNoModalJ10 from '@aims/shared/components/YesNoModalJ10';
import { getQuarterLabel } from '@aims/shared/reports/quarters';
import { DeleteOutlined } from '@ant-design/icons';
import { gql, useMutation } from '@apollo/client';
import { Button, Divider, Typography, notification } from 'antd';
import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const deleteUpgQuarterlyReportMutation = gql`
  mutation DeleteUpgQuarterlyReportForUser($_id: ID!) {
    deleteUpgQuarterlyReportForUser(_id: $_id) {
      deletedId
    }
  }
`;

const { Paragraph } = Typography;

function DeleteReportButton({ report, peopleGroupId }) {
  const [deleting, setDeleting] = useState();
  const onDelete = (o) => setDeleting(o);
  const onCancelDelete = () => setDeleting(undefined);

  const [loading, setLoading] = useState(false);
  const [deleteReport] = useMutation(deleteUpgQuarterlyReportMutation);
  const history = useHistory();

  const onYes = useCallback(async () => {
    setLoading(true);
    try {
      await deleteReport({
        variables: {
          _id: report._id,
        },
      });
      notification.success({
        message: 'Deleted',
        description: 'Report deleted successfully',
      });
      history.push(`/upgs/${peopleGroupId}/reports`);
    } catch (err) {
      notification.error({
        message: 'Error',
        description: 'We apologize.  An error occurred.',
      });
      setLoading(false);
    }
  }, [report, deleteReport, history, peopleGroupId]);

  return (
    <>
      <YesNoModalJ10
        title="Delete Report Draft"
        yesText="Delete Report"
        noText="Cancel"
        question={`Are you sure you want to delete this quarterly report draft?`}
        onYes={onYes}
        onNo={onCancelDelete}
        visible={deleting}
        loading={loading}
      >
        <Paragraph>Are you sure you want to delete this report?</Paragraph>
        <Paragraph>
          {`${getQuarterLabel(report.quarter)} (${peopleGroupId})`}
        </Paragraph>
      </YesNoModalJ10>
      <div>
        <Divider />
        <div className="delete-box">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button onClick={onDelete} icon={<DeleteOutlined />} danger ghost>
              Delete Report
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default DeleteReportButton;
